module.exports = __webpack_public_path__ + "img/Jasper - Facepalm.29347f4b.png";